import React from "react";
import PropTypes from "prop-types";
import {useTranslation} from "react-i18next";
import {Controller, useForm} from "react-hook-form";

import {classNames} from "../../../utils/Utils";
import InputText from "../../../components/common/form/input-text";
import InputSubmit from "../../../components/common/form/input-submit";
import PaymentTermsConditions from "../../../routes/account/company/configuration/payment-terms-conditions";
import {Warning} from "../../../components/common/alert/banner";
import {HEADER_COMPACT_CLASS} from "./document-header-utils";

const PaymentTermModalForm = ({onSubmitData, isLoading, exception}) => {
    const {t} = useTranslation();
    const {
        control,
        register,
        handleSubmit,
        formState: {errors},
    } = useForm({
        defaultValues: {
            name: "",
            code: "",
            description: "",
            condition_type: [
                {id: 1, percent: 100, days: 0, unit: "after_invoice_date"},
            ],
        },
    });

    return (
        <form
            onSubmit={handleSubmit(onSubmitData)}
            className={classNames("space-y-3", HEADER_COMPACT_CLASS)}
        >
            <InputText
                id="payment_term_name"
                type="text"
                label={t("document.form.payment_term_name", {defaultValue: "Nome"})}
                errors={errors.name}
                input={{
                    ...register("name", {
                        required: true,
                        validate: (value) => (value ?? "").trim().length > 0,
                    }),
                }}
                isRequired
            />

            <InputText
                id="payment_term_code"
                type="text"
                label={t("document.form.payment_term_code", {defaultValue: "Codice"})}
                errors={errors.code}
                input={{
                    ...register("code", {
                        required: true,
                        validate: (value) => (value ?? "").trim().length > 0,
                    }),
                }}
                isRequired
            />

            <Controller
                control={control}
                name="condition_type"
                rules={{validate: (value) => Array.isArray(value) && value.length > 0}}
                render={({field: {value, onChange}}) => (
                    <PaymentTermsConditions
                        baseValue={value ?? []}
                        onChange={onChange}
                        translationBase="document.form"
                    />
                )}
            />

            <InputText
                id="payment_term_description"
                type="textarea-2"
                label={t("document.form.payment_term_description", {defaultValue: "Descrizione"})}
                errors={errors.description}
                input={{...register("description")}}
            />

            {exception && <Warning message={exception} />}

            <div className="pt-2">
                <InputSubmit
                    isLoading={isLoading}
                    isFullWith
                    label={t("app.form.save", {defaultValue: "Salva"})}
                />
            </div>
        </form>
    );
};

PaymentTermModalForm.propTypes = {
    onSubmitData: PropTypes.func,
    isLoading: PropTypes.bool,
    exception: PropTypes.string,
};

PaymentTermModalForm.defaultProps = {
    onSubmitData: null,
    isLoading: false,
    exception: null,
};

export default PaymentTermModalForm;
